module.exports = __webpack_public_path__ + "img/unnamedjj.22a79561.png";